import { lazy } from 'react';

import { withSuspense } from '@/shared/lib/hocs/with-suspense.hoc';
import { PageLoader } from '@/widgets/page';

export const AlarmDashboardPage = withSuspense(
	lazy(async () => await import('./alarm-dashboard-page.component')),
	PageLoader,
);
